
import Folder2 from "../../../assets/outline/Folder2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Folder2Icon({ className, dataTestid = "Folder2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Folder2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
